import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { sm },
} = constants.breakpoints;

const white = constants.colors.brand.white[100];
const grey = constants.colors.ui.neutral[500];
const greyLight = constants.colors.ui.neutral[100];

export const modalCss = {
  width: "100%",
  boxShadow: "0px 16px 40px rgba(0, 0, 0, 0.32)",
  zIndex: 99,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const modalWrapper = {
  borderRadius: "16px",
  background: white,
  boxShadow: "0px 2px 6px 0px rgba(29, 29, 29, 0.16)",
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  justifyContent: "center",
  position: "relative" as const,
  padding: 20,
  gap: 10,
  margin: "0px 18px",
  width: "800px",
  height: "523px",
};

export const modalTitle = {
  margin: 0,
  alignSelf: "flex-start",
  fontSize: 20,
};

export const tittleWrapper = {
  borderBottom: "1px solid" + greyLight,
  width: "100%",
  flexDirection: "row" as const,
  justifyContent: "space-between",
  display: "flex",
  padding: "20px",
};

export const modalFooterCss = {
  display: "flex",
  flexDirection: "row" as const,
  alignItems: "center",
  height: "81px",
  width: "100%",
  padding: "16px",
  justifyContent: "space-between",
  borderTop: "1px solid" + greyLight,
};

export const footerButtonsWrapper = {
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  flex: "0 0 auto",
  "&> button:last-child": {
    flex: "0 0 auto",
    marginLeft: "auto",
  },
  "&>button:nth-of-type(2)": {
    marginRight: 0,
  },
};

export const cancelButtonCss = {
  marginRight: "10px",
};

export const closeButtonCss = {
  alignSelf: "end",
  marginTop: "2px",
  [mq.downTo(sm)]: {
    marginTop: "0px",
  },
  color: grey,
  "& svg": {
    height: "20px",
  },
};

export const modalContentWrapper = {
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  height: "70%",
  h1: {
    lineHeight: "40px",
    fontSize: "32px",
  },
  p: {
    lineHeight: "32px",
    fontSize: "16px",
  },
};

export const modalContentText = {
  width: "45%",
  margin: "auto",
};

export const modalContentImageWrapper = {
  width: "40%",
  margin: "auto",
};

export const modalContentImage = {
  margin: "auto",
  width: "100%",
};

export const footerNextButton = {
  display: "flex",
  justifyContent: "flex-end",
};

export const checkboxCss = {
  padding: 0,
};

export const modalPaginationWrapper = {
  display: "flex",
};

export const modalPagination = (isCurrentPage: boolean) => {
  return {
    display: "flex",
    circle: {
      fill: isCurrentPage ? grey : greyLight,
      stroke: isCurrentPage ? grey : greyLight,
    },
  };
};
